import { Component, computed, OnInit, signal } from '@angular/core';
import { AuditService } from './audit.service';
import { AuditRecordDto, AuditRecordLookupDto } from './audit.models';
import { saveAs } from 'file-saver-es';

@Component({
  selector: 'app-audit-viewer',
  standalone: false,
  templateUrl: './audit-viewer.component.html',
})
export class AuditViewerComponent implements OnInit  {

  // Signals for audit records and selection
  auditRecords = signal<AuditRecordLookupDto[]>([]);
  selectedRecord = signal<AuditRecordDto | null>(null);
  loading = signal(false);

  constructor(private auditService: AuditService) {
  }

  ngOnInit(): void {
    this.loadAuditList();
  }

  loadAuditList() {
    this.auditService.getAuditList().subscribe({
      next: (result) => this.auditRecords.set(result),
      error: (err) => console.error('Failed to load audit list', err)
    });
  }

  selectRecord(record: AuditRecordLookupDto) {
    this.loading.set(true);
    this.auditService.getAuditRecord(record.id).subscribe({
      next: (result) => {
        this.selectedRecord.set(result);
        this.loading.set(false);
      },
      error: (err) => {
        console.error('Failed to load record', err);
        this.loading.set(false);
      }
    });
  }

  // Computed signals for pretty JSON
  dataJson = computed(() => {
    const raw = this.selectedRecord()?.data ?? '';
    return this.formatJson(raw);
  });

  additionalInfoJson = computed(() => {
    const raw = this.selectedRecord()?.additionalInfo ?? '';
    return this.formatJson(raw);
  });

  formatJson(raw: string) {
    try {
      const obj = JSON.parse(raw);
      return JSON.stringify(obj, null, 2);
    } catch {
      return raw; // not valid JSON, just show as-is
    }
  }

  downloadDataJson() {
    const record = this.selectedRecord();
    if (record && record.data) {
      const filename = `audit_data_${record.id}.json`;
      const jsonStr = JSON.stringify(JSON.parse(record.data), null, 2);
      const blob = new Blob([jsonStr], { type: 'application/json' });
      saveAs(blob, filename);
    } else {
      console.warn('No data available to download for the selected record.');
      // Optionally, you could display a message to the user.
    }
  }

}